import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { AuthTokens, Crew } from '@lemoment/shared';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  crew: Crew | null;
  setAuth: (tokens: AuthTokens, crew: Crew) => void;
  setAccessToken: (accessToken: string) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      crew: null,
      setAuth: (tokens, crew) =>
        set({
          accessToken: tokens.accessToken,
          refreshToken: tokens.refreshToken,
          crew,
        }),
      setAccessToken: (accessToken) => set({ accessToken }),
      clear: () => set({ accessToken: null, refreshToken: null, crew: null }),
    }),
    { name: 'lemoment_auth' },
  ),
);
